module.exports = __webpack_public_path__ + "static/media/placement_salary2026.5749bbb8.png";